(function ($) {
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    $(function () {
        //Animate on scroll
        AOS.init({
            delay: 100,
            duration: 600,
            offset: 200
        });

        //change sku text when variants are selected
        $('.product--product-template, .featured-product').on('variantSkuChange', function (e) {
            $('.variant-sku .value').text(e.variant.sku);
            $('.tacmed-quote-item').val(e.variant.sku);
            $('.rfq').each(function () {
                var base = $(this).data('base');
                var title = $(this).data('title');
                $(this).attr({
                    'href': base + '?sku=' + e.variant.sku + '&title=' + title
                });
            })
        });

        //product video carousel
        $('.product-video-wrapper').flickity({
            cellSelector: '.product-video',
            cellAlign: 'center',
            contain: true,
            groupCells: true,
            imagesLoaded: true,
            lazyLoad: true,
            pageDots: false,
            adaptiveHeight: false,
            arrowShape: {
                x0: 20,
                x1: 65,
                y1: 35,
                x2: 70,
                y2: 30,
                x3: 30
            }
        });

        $('.tab-nav li').first().addClass('active');
        $('.tab').first().addClass('active')
        $('.tab-nav li a').on('click', function () {
            if (!$(this).closest('li').hasClass('active')) {
                var target = $(this).attr('href');
                console.log(target);
                $('.tab, .tab-nav li').removeClass('active');
                $(target).addClass('active');
                $(this).closest('li').addClass('active');
            }
            return false;
        });

        var status = getParameterByName('status');
        if (status == 'captchafail' || status == 'fail') {
            $('div.form-success').hide();
            $('div.form-error').show();
        }

        // var reCaptchaLoaded = false;
        // $('.tacmed-form input').on('focus', function () {
        //     console.log('form interacted');
        //     if(reCaptchaLoaded == false) {
        //         console.log('recaptcha loaded');
        //         var head = document.getElementsByTagName('head')[0];
        //         var script = document.createElement('script');
        //         script.type = 'text/javascript';
        //         script.src = 'https://www.google.com/recaptcha/api.js';
        //         head.appendChild(script);
        //         reCaptchaLoaded = true;
        //     }
        // });

        var widget_id = 0;
        $('.tacmed-form').each(function () {
            $(this).attr('data-widget-id', widget_id++);
        });

        $('.tacmed-form').on('submit', function (e) {
            e.preventDefault();
            grecaptcha.execute($(this).attr('data-widget-id'));
        });

        if ($('.tacmed-quote-item').length > 0) {
            $('.tacmed-quote-item').val($('.variant-sku .value').text());
        }
        $('a[href="#Medical-Support-Form"], a[href="#Protection-Support-Form"], a[href="#Simulation-Support-Form"], a[href="#Request-Quote-Form"]').magnificPopup({
            autoFocusLast: false,
            mainClass: 'tacmed-form-popup'
        });

        $('.support-sku').selectize({
            persist: false,
            sortField: 'text'
        });

        if ($('#Request-Quote-Form').length > 0) {
            var urlParams = new URLSearchParams(window.location.search);
            var sku = urlParams.get('sku');
            var title = urlParams.get('title');
            copyIndex(sku, title);
            $(document).on('click', '.quote-repeater .adder', function () {
                copyIndex();
            })
            $(document).on('click', '.quote-item .remover', function () {
                $(this).closest('.quote-item').remove();
            });
        }

        function copyIndex(sku, title) {
            var newField = $('#clone .quote-item').clone();
            $(newField).appendTo('.quote-repeater .inner');

            var $select = $(newField).find('select').selectize({
                persist: false,
                sortField: 'text'
            });
            var selectize = $select[0].selectize;
            if (sku && title) {
                selectize.addOption({
                    sku: title
                });
                selectize.setValue(sku, false);
                // var element = '<option selected value="'+sku+'">' + title + '</option>';
                // $('.quote-repeater .quote-item:only-child .tacmed-quote-item').prepend(element);
                // $('.quote-repeater .quote-item:only-child .tacmed-quote-item .quantity').
            }

            // console.log($('#quote-form').serialize());
        }

    });
})(jQuery);